import { useQuery } from "@tanstack/react-query";

import SettingsService from "services/Settings";

/**
 * The tenant's Green, Yellow and Red proximity distances, in metres.
 *
 * Left at the query client's default zero stale time on purpose: an admin
 * editing the limits has to reach every map opened afterwards, and the payload
 * is three integers.
 *
 * @returns {Object} The React Query result. `data` is undefined for a tenant
 *   whose limits are unset or unreadable, which callers treat as "no bands".
 */
export function useDistanceLimits() {
  return useQuery({
    queryKey: ["settings", "distanceLimits"],
    queryFn: SettingsService.getDistanceLimits,
    // A tenant whose settings cannot be read still gets a working map, so a
    // failure here is not worth three more round trips.
    retry: false,
  });
}
